//https://stackoverflow.com/questions/384286/how-do-you-check-if-a-javascript-object-is-a-dom-object/384380#384380
function isElement(obj) {
    try {
        return obj instanceof HTMLElement;
    }
    catch(e){
        return (typeof obj==="object") &&
            (obj.nodeType===1) && (typeof obj.style === "object") &&
            (typeof obj.ownerDocument ==="object");
    }
}

function detectCollision(rect1, rect2) {
    if( ( ( rect1.xStart <= rect2.xStart && rect2.xStart <= rect1.xEnd ) ||
        ( rect1.xStart <= rect2.xEnd && rect2.xEnd <= rect1.xEnd ) ) &&
        ( ( rect1.yStart <= rect2.yStart && rect2.yStart <= rect1.yEnd ) ||
            ( rect1.yStart <= rect2.yEnd && rect2.yEnd <= rect1.yEnd ) )
    ) {
        return true;
    } else {
        return false;
    }
}
/**
 * @param e Element
 * @return Object
 */
function createBoundingClientRect(e) {
    var x = (window.pageXOffset !== undefined)
        ? window.pageXOffset
        : (document.documentElement || document.body.parentNode || document.body).scrollLeft;
    var y = (window.pageYOffset !== undefined)
        ? window.pageYOffset
        : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    var rect = e.getBoundingClientRect();
    var width = rect.width;
    var height = rect.height;
    var xStart = rect.left + x;
    var xEnd = xStart + width;
    var yStart = rect.top + y;
    var yEnd = yStart + height;
    return {
        rect: rect,
        width: width,
        height: height,
        xStart: xStart,
        xEnd: xEnd,
        yStart: yStart,
        yEnd: yEnd
    };
}

export default {
    checkIfUserScrolledToTheBottom() {
        // const element = document.body;
        // const bodyHeight = element.clientHeight; // bodyの高さを取得
        const bodyHeight = document.querySelector('#app').clientHeight;
        const windowHeight = window.innerHeight; // windowの高さを取得
        const bottomPoint = bodyHeight - windowHeight; // ページ最下部までスクロールしたかを判定するための位置を計算
        const currentPos = window.pageYOffset; // スクロール量を取得
        return bottomPoint <= Math.ceil(currentPos);
    },
    checkElementIsInViewport(element) {
        if ( !isElement(element) ) return false;
        const rect = element.getBoundingClientRect();
        return 0 < rect.bottom && rect.top < window.innerHeight;
    },
    sanitize: {
        encode : function (_str) {
            return _str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
        },
        decode : function (_str) {
            return _str.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, '\'').replace(/&amp;/g, '&');
        }
    },
    detectCollision(el1, el2) {
        const rect1 = createBoundingClientRect(el1);
        const rect2 = createBoundingClientRect(el2);
        return detectCollision(rect1, rect2);
    },
    generateQueryParam(name, params, search_text) {
        const url_search_params = new URLSearchParams();
        for(const param of params) url_search_params.append(name, param);
        if(search_text) url_search_params.append('search_text', search_text);
        return url_search_params.toString();
    },
}
